import { ThunkAction } from 'redux-thunk';
import * as Bixby from '../../core';
import { AppState } from '..';
import {
  ALL_CLO_DEAL_BIXBYID_MAPPING_FAILURE,
  ALL_CLO_DEAL_BIXBYID_MAPPING_LOADING,
  ALL_CLO_DEAL_BIXBYID_MAPPING_SUCCESS,
  ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_FAILURE,
  ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_LOADING,
  ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_SUCCESS,
} from './types';
import { CloDealService } from '$/services';
import { toastError, toastSuccess } from '../toast/actions';


export const allCloDealBixbyIdMappingFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ALL_CLO_DEAL_BIXBYID_MAPPING_FAILURE,
    payload: error,
    addError: true,
  };
};

export const allCloDealBixbyIdMappingSuccessAction = (payload: Bixby.Models.CloDealBixbyIdMapping[]) => {
  return {
    type: ALL_CLO_DEAL_BIXBYID_MAPPING_SUCCESS,
    payload,
  };
};

export const allCloDealBixbyIdMappingLoadingAction = () => {
  return {
    type: ALL_CLO_DEAL_BIXBYID_MAPPING_LOADING,
  };
};


export const allCloDealBixbyIdMappingUpdateFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_FAILURE,
    payload: error,
    addError: true,
  };
};

export const allCloDealBixbyIdMappingUpdateSuccessAction = () => {
  return {
    type: ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_SUCCESS,
  };
};

export const allCloDealBixbyIdMappingUpdateLoadingAction = () => {
  return {
    type: ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_LOADING,
  };
};

export const getAllCloDealBixbyIdMappings =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(allCloDealBixbyIdMappingLoadingAction());
    try {
      const data = await CloDealService.getAllCloDealBixbyIdMappings();
      dispatch(allCloDealBixbyIdMappingSuccessAction(data));
    } catch (error: any) {
      dispatch(allCloDealBixbyIdMappingFailureAction(error));
    }
  };

export const updateCloDealBixbyIdMapping =
  (id: string, bixbyId: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(allCloDealBixbyIdMappingUpdateLoadingAction());
    try {
      await CloDealService.updateCloDealBixIdMapping(id, bixbyId);
      dispatch(allCloDealBixbyIdMappingUpdateSuccessAction());
      dispatch(toastSuccess(`Mapping updated successfully`));
    } catch (error: any) {
      dispatch(toastError(`Error update mapping`));
      dispatch(allCloDealBixbyIdMappingUpdateFailureAction(error));
    }
  };
